import type {
  BotProtectionRuntimeEvent,
  BotProtectionWidgetCallbacks,
} from './types'

export const toAdapterRuntimeEvent = (event: BotProtectionRuntimeEvent): BotProtectionRuntimeEvent => event

export const toTurnstileCallbacks = (callbacks: BotProtectionWidgetCallbacks) => ({
  callback: (token: string) => callbacks.onToken(token),
  'expired-callback': () => callbacks.onExpired(),
  'error-callback': (errorCode?: string) => callbacks.onError(errorCode),
  'timeout-callback': () => callbacks.onTimeout(),
})
